@if (visible()) {
<div> <!-- class="jk-numberedit-border" -->
  <div [ngStyle]="flexStyle" class="items-center">
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
    <button mat-icon-button matPrefix (click)="decrement()">
      <mat-icon>remove</mat-icon>
    </button>
    <input matInput class="jk-numberedit" type="number" [ngStyle]="widthStyle" [min]="min()" [max]="max()"
      style="width: 100%" (change)="onValueChange($event)" [disabled]="disabled()" [readonly]="readonly()"
      [required]="required()" [(ngModel)]="value" />
    <button mat-icon-button matSuffix (click)="increment()">
      <mat-icon>add</mat-icon>
    </button>

  </div>
</div>
}